import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
		<path
			fill='#ee2b7b'
			d='M20 20H4a2 2 0 0 1-2-2l.01-12a1.993 1.993 0 0 1 .581-1.414A1.973 1.973 0 0 1 4 4h6l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Zm-9.875-8a.626.626 0 0 0-.625.625v.75a.626.626 0 0 0 .625.625H11v.875a.626.626 0 0 0 .625.625h.75a.626.626 0 0 0 .625-.625V14h.875a.626.626 0 0 0 .625-.625v-.75a.626.626 0 0 0-.625-.625H13v-.875a.626.626 0 0 0-.625-.625h-.75a.626.626 0 0 0-.625.625V12h-.875Z'
			data-name='Sustracci\xF3n 8'
		/>
		<path fill='none' d='M0 0h24v24H0Z' data-name='Trazado 74123' />
	</svg>
)
export default SvgComponent
